import SpaceObjectInfo from './SpaceObjectInfo.component';

export default SpaceObjectInfo;